import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { Sgke111aResponseInitialhyojiInfo, Sgke112aResponseGamenHyojiInfo, Sgke112aResponseInitialhyojiInfo } from 'sg-api';

@Component({
  selector: 'app-sgke110d-info',
  templateUrl: './sgke110d-info.component.html',
  styleUrl: './sgke110d-info.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})

export class Sgke110dInfoComponent implements OnInit, OnDestroy {

  /** モーダル表示フラグ */
  @Input() isMordal: boolean;
  /** 編集フラグ */
  @Input() isEdit: boolean;
  /** 初期表示情報（新規）_検索結果 */
  @Input() newInitialhyojiInfo: Sgke111aResponseInitialhyojiInfo;
  /** 初期表示情報（訂正）_検索結果 */
  @Input() correctionInitialhyojiInfo: Sgke112aResponseInitialhyojiInfo;
  /** 画面表示情報（訂正）_検索結果 */
  @Input() gamenHyojiInfo: Sgke112aResponseGamenHyojiInfo;

  /** 【モーダル確認】モーダルボタン押下 */
  @Output() clickMordalEvent = new EventEmitter();
  /** キャンセルボタン押下イベント*/
  @Output() cancelButtonClickEmitter = new EventEmitter();
  /** 削除ボタン押下イベント*/
  @Output() removeButtonClickEmitter = new EventEmitter();


  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  private parentForm: UntypedFormGroup;

  // 訂正後入金額スタイル
  afteiseiInmnyStyle: { [key: string]: string } = {};

  /** 入金通知報告登録APIリクエストDto FormGroup */
  rcvmnyRegInfDto: UntypedFormGroup;

  /** 会社リスト */
  companyList: SelectBox[] = [];
  /** 入金地区リスト */
  rcvmnyAreaList: SelectBox[] = [];
  /** 入金口座リスト */
  rcvmnyKouzaList: SelectBox[] = [];
  /** 入金形態リスト */
  rcvmnyKeitaiList: SelectBox[] = [];
  /** 口座入金機関リスト */
  kouzaRcvmnyFcltList: SelectBox[] = [];

  /**
   * コンストラクタ
   * @param {UntypedFormBuilder} fb 
   * @param {TimeApiService} timeApiService
   * @param {FormGroupDirective} parent
   */
  constructor(
    private fb: UntypedFormBuilder,
    public timeApiService: TimeApiService,
    private parent: FormGroupDirective,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke110dInfoComponent
   */
  ngOnInit(): void {

    this.parentForm = this.parent.form;

    if (this.isMordal) {
      // モーダル画面の場合
      if(this.isEdit){
        // 訂正登録の場合
        this.createCorrectionForm();
        this.onChangeAfteiseiInmny();
        this.parentForm.addControl("updateInfo", this.rcvmnyRegInfDto);
      }else{
        // 新規登録の場合
        this.createNewModalForm();
        this.parentForm.addControl("reginf", this.rcvmnyRegInfDto);
      }
      this.setCorrectionSelectList();
    } else {
      // 新規登録の場合
      this.createNewForm();
      this.setNewSelectList();
      this.onChangeRcvmnyKeitai();
      this.parentForm.addControl("reginf", this.rcvmnyRegInfDto);
    }

  }

  /**
   * 最終処理
   * @memberof Sgke110dInfoComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    if (this.isEdit) {
      this.parentForm.removeControl('updateInfo');
    } else {
      this.parentForm.removeControl('reginf');
    }

  }

  /**
   * 入金形態変更時処理
   * @memberof Sgke110dInfoComponent
   */
  onChangeRcvmnyKeitai(): void {
    // 入金形態の選択値取得
    const value = this.rcvmnyRegInfDto.controls['rcvmnyKeitaiCode'].value;
    // 入金形態リスト
    const parentList = this.newInitialhyojiInfo?.rcvmnyKeitaiCode;
    // 入金形態に紐づく口座入金機関取得
    const parent = parentList?.find(obj => obj.codeValue.includes(value));
    const childList = parent?.kouzaRcvmnyBankofficecode;
    // 口座入金機関を口座入金機関コンボボックスに設定
    this.kouzaRcvmnyFcltList = childList?.map((child) => {
      let selectBox: SelectBox = {
        value: child.codeValue,
        viewValue: child.aname
      };
      return selectBox;
    });

    let ctrl = this.rcvmnyRegInfDto.controls['kouzaRcvmnyBankofficecode'];
    // 入金形態が選択状態なら有効、未選択(=null)の場合は無効
    if (!this.isEdit && value) {
      ctrl.enable();
    } else {
      ctrl.disable();
    }
    ctrl.reset();
  }

  /**
   * 訂正後入金額変更時処理
   * @memberof Sgke110dInfoComponent
   */
  onChangeAfteiseiInmny(): void {
    const noCommaAfteiseiInmny = this.rcvmnyRegInfDto.controls['afteiseiInmny'].value;
    if (noCommaAfteiseiInmny > this.gamenHyojiInfo.befteiseiInmny) {
      this.afteiseiInmnyStyle = {
        backgroundColor: 'yellow',
      };
    } else {
      this.afteiseiInmnyStyle = {
        backgroundColor: '',
      };
    }
  }

  /**
   * 入力欄のデザイン切り替え
   * @param {string} ctrlName
   * @return {*}
   * @memberof Sgke110dInfoComponent
   */
  getAppearance(ctrlName: string) {
    const enabled = this.rcvmnyRegInfDto.controls[ctrlName]?.enabled;
    return enabled ? 'outline' : 'fill';
  }

  /**
   * キャンセルボタン押下時
   * @memberof Sgke110dInfoComponent
   */
  onClickCancel(): void {
    this.cancelButtonClickEmitter.emit();
  }

  /**
   * 削除ボタン押下時
   * @memberof Sgke110dInfoComponent
   */
  onClickRemove(): void {
    this.removeButtonClickEmitter.emit();
  }

  /**
   * 新規フォーム作成
   * @private
   * @memberof Sgke110dInfoComponent
   */
  private createNewForm() {
    this.rcvmnyRegInfDto = this.fb.group({
      // 会社
      companycode: this.fb.nonNullable.control({ value: '', disabled: this.isEdit }, Validators.required),
      // 入金地区
      rcvmnyAreacode: this.fb.nonNullable.control({ value: '', disabled: this.isEdit }, Validators.required),
      // 口座入金年月日
      kouzaRcvmnyYearmonthdate: this.fb.nonNullable.control({ value: '', disabled: this.isEdit }, Validators.required),
      // 入金口座
      rcvmnyKouzacode: this.fb.nonNullable.control({ value: '', disabled: this.isEdit }, Validators.required),
      // 入金形態
      rcvmnyKeitaiCode: this.fb.nonNullable.control({ value: '', disabled: this.isEdit }, Validators.required),
      // 口座入金機関
      kouzaRcvmnyBankofficecode: this.fb.nonNullable.control({ value: '', disabled: true }, Validators.required),
      // 口座入金額
      kouzaRcvmnyAmt: this.fb.nonNullable.control({ value: '', disabled: this.isEdit }, Validators.required),
      // 入金通知報告管理番号
      rcvmnyNotificationreportMno: this.newInitialhyojiInfo?.rcvmnyNotificationreportMno,
      // 入金通知報告履歴番号
      rcvmnyNotificationreportRrkno: this.newInitialhyojiInfo?.rcvmnyNotificationreportRrkno,
      // 入金突合結果管理番号
      rcvmnyReconciliationresultMno: this.newInitialhyojiInfo?.rcvmnyReconciliationresultMno,
      // 入金突合結果_更新通番号
      rcvmnyreconciliationResultUpdatesequencenumber: this.newInitialhyojiInfo?.rcvmnyreconciliationResultUpdatesequencenumber,
    });
  }

    /**
   * モーダル時新規登録フォーム作成
   * @private
   * @memberof Sgke110dInfoComponent
   */
    private createNewModalForm() {
      this.rcvmnyRegInfDto = this.fb.group({
        // 会社
        companycode: [{ value: this.gamenHyojiInfo?.companycode, disabled: true }],
        // 入金地区
        rcvmnyAreacode: [{ value: this.gamenHyojiInfo?.rcvmnyAreacode, disabled: true }],
        // 口座入金年月日
        kouzaRcvmnyYearmonthdate: [{ value: this.timeApiService.convertStringToDate(this.gamenHyojiInfo?.kouzaRcvmnyYearmonthdate), disabled: true }],
        // 入金口座
        rcvmnyKouzacode: [{ value: this.gamenHyojiInfo?.rcvmnyKouzacode, disabled: true }],
        // 入金形態
        rcvmnyKeitaiCode: [{ value: this.gamenHyojiInfo?.rcvmnyKeitaiCode, disabled: true }],
        // 口座入金機関
        kouzaRcvmnyBankofficecode: [{ value: this.gamenHyojiInfo?.kouzaRcvmnyBankofficecode, disabled: true }],
        // 口座入金額
        kouzaRcvmnyAmt: this.fb.nonNullable.control({ value: '', disabled: false }, Validators.required),
        // 入金通知報告管理番号
        rcvmnyNotificationreportMno: this.correctionInitialhyojiInfo?.rcvmnyNotificationreportMno,
        // 入金通知報告履歴番号
        rcvmnyNotificationreportRrkno: this.correctionInitialhyojiInfo?.rcvmnyNotificationreportRrkno,
        // 入金突合結果管理番号
        rcvmnyReconciliationresultMno: this.correctionInitialhyojiInfo?.rcvmnyReconciliationresultMno,
        // 入金突合結果_更新通番号
        rcvmnyreconciliationResultUpdatesequencenumber: this.gamenHyojiInfo?.rcvmnyreconciliationResultUpdatesequencenumber,
      });
    }

  /**
   * 訂正フォーム作成
   * @private
   * @memberof Sgke110dInfoComponent
   */
  private createCorrectionForm() {
    this.rcvmnyRegInfDto = this.fb.group({
      // 会社
      companycode: [{ value: this.gamenHyojiInfo?.companycode, disabled: this.isEdit }],
      // 入金地区
      rcvmnyAreacode: [{ value: this.gamenHyojiInfo?.rcvmnyAreacode, disabled: this.isEdit }],
      // 口座入金年月日
      kouzaRcvmnyYearmonthdate: [{ value: this.timeApiService.convertStringToDate(this.gamenHyojiInfo?.kouzaRcvmnyYearmonthdate), disabled: this.isEdit }],
      // 入金口座
      rcvmnyKouzacode: [{ value: this.gamenHyojiInfo?.rcvmnyKouzacode, disabled: this.isEdit }],
      // 入金形態
      rcvmnyKeitaiCode: [{ value: this.gamenHyojiInfo?.rcvmnyKeitaiCode, disabled: this.isEdit }],
      // 口座入金機関
      kouzaRcvmnyBankofficecode: [{ value: this.gamenHyojiInfo?.kouzaRcvmnyBankofficecode, disabled: this.isEdit }],
      // 訂正前入金額
      befteiseiInmny: [{ value: this.gamenHyojiInfo?.befteiseiInmny, disabled: this.isEdit }],
      // 訂正後入金額
      afteiseiInmny: this.fb.nonNullable.control({ value: this.gamenHyojiInfo?.afteiseiInmny, disabled: false }, Validators.required),
      // 入金通知報告管理番号
      rcvmnyNotificationreportMno: this.correctionInitialhyojiInfo?.rcvmnyNotificationreportMno,
      // 入金通知報告履歴番号
      rcvmnyNotificationreportRrkno: this.correctionInitialhyojiInfo?.rcvmnyNotificationreportRrkno,
      // 入金通知報告_更新通番号
      rcvmnyNotificationreportUpdatesequencenumber: this.gamenHyojiInfo?.rcvmnyNotificationreportUpdatesequencenumber,
      // 入金突合結果管理番号
      rcvmnyReconciliationresultMno: this.correctionInitialhyojiInfo?.rcvmnyReconciliationresultMno,
      // 入金突合結果_更新通番号
      rcvmnyreconciliationResultUpdatesequencenumber: this.gamenHyojiInfo?.rcvmnyreconciliationResultUpdatesequencenumber,
    });
  }

  /**
   * 選択リストに値を設定
   * @private
   * @memberof Sgke110dInfoComponent
   */
  private setNewSelectList() {
    // 会社リスト
    const companycodeList = this.newInitialhyojiInfo?.companycode;
    this.companyList = companycodeList?.map((companycode) => {
      let selectBox: SelectBox = {
        value: companycode.codeValue,
        viewValue: companycode.aname
      };
      return selectBox;
    });

    // 会社リスト1件目を選択
    this.rcvmnyRegInfDto.controls['companycode'].setValue(this.companyList[0].value);

    // 入金地区リスト
    // 会社に紐づく入金地区取得
    const companycode = companycodeList?.find(obj => obj.codeValue.includes(this.companyList[0].value));
    const rcvmnyAreacodeList = companycode?.rcvmnyAreacode;
    // 入金地区を入金地区コンボボックスに設定
    this.rcvmnyAreaList = rcvmnyAreacodeList?.map((child) => {
      let selectBox: SelectBox = {
        value: child.codeValue,
        viewValue: child.aname
      };
      return selectBox;
    });

    // 入金地区リスト1件目を選択
    this.rcvmnyRegInfDto.controls['rcvmnyAreacode'].setValue(this.rcvmnyAreaList[0].value);

    // 入金口座リスト
    this.rcvmnyKouzaList = this.newInitialhyojiInfo?.rcvmnyKouzacode?.map((rcvmnyKouzacode) => {
      let selectBox: SelectBox = {
        value: rcvmnyKouzacode.codeValue,
        viewValue: rcvmnyKouzacode.aname
      };
      return selectBox;
    });

    // 入金形態リスト
    this.rcvmnyKeitaiList = this.newInitialhyojiInfo?.rcvmnyKeitaiCode?.map((rcvmnyKeitai) => {
      let selectBox: SelectBox = {
        value: rcvmnyKeitai.codeValue,
        viewValue: rcvmnyKeitai.aname
      };
      return selectBox;
    });
  }

  /**
   * 選択リストに値を設定
   * @private
   * @memberof Sgke110dInfoComponent
   */
  private setCorrectionSelectList() {
    // 会社リスト
    let companySelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.companycode,
      viewValue: this.gamenHyojiInfo?.company,
    };
    this.companyList.push(companySelectBox);

    // 入金地区リスト
    let rcvmnyAreaSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.rcvmnyAreacode,
      viewValue: this.gamenHyojiInfo?.rcvmnyArea,
    };
    this.rcvmnyAreaList.push(rcvmnyAreaSelectBox);

    // 入金口座リスト
    let rcvmnyKouzaSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.rcvmnyKouzacode,
      viewValue: this.gamenHyojiInfo?.rcvmnyKouza,
    };
    this.rcvmnyKouzaList.push(rcvmnyKouzaSelectBox);

    // 入金形態リスト
    let rcvmnyKeitaiSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.rcvmnyKeitaiCode,
      viewValue: this.gamenHyojiInfo?.rcvmnyKeitai,
    };
    this.rcvmnyKeitaiList.push(rcvmnyKeitaiSelectBox);

    // 口座入金機関
    let kouzaRcvmnyFcltSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.kouzaRcvmnyBankofficecode,
      viewValue: this.gamenHyojiInfo?.kouzaRcvmnyFclt,
    };
    this.kouzaRcvmnyFcltList.push(kouzaRcvmnyFcltSelectBox);

  }

}
